import Vue from 'vue';
import Vuex from 'vuex';
import authStore from "@/store/authStore";

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        authStore
    }
})
